const EMPTY_STATUS_COUNTS = {
  available: false,
  assigned: null,
  completed: 0,
  inProgress: 0,
  notStarted: 0,
  notDelivered: 0,
  remindable: {
    inProgress: 0,
    notStarted: 0,
  },
}

export const adaptCampaignStatusCounts = (payload) => {
  if (!payload?.available) {
    return EMPTY_STATUS_COUNTS
  }

  return {
    available: true,
    assigned: payload.assigned,
    completed: payload.completed,
    inProgress: payload.inProgress,
    notStarted: payload.notStarted,
    notDelivered: payload.notDelivered || 0,
    remindable: {
      inProgress: payload.remindable?.inProgress ?? 0,
      notStarted: payload.remindable?.notStarted ?? 0,
    },
  }
}
